import { Reveal } from '@/components/motion/Reveal'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { useTranslations } from '@/app/site-context'

export function Integrations() {
  const { integrations } = useTranslations()

  return (
    <section
      className="integrations section"
      id="integrations"
      aria-labelledby="integrations-title"
    >
      <SectionHeading
        title={integrations.title}
        id="integrations-title"
        lede={integrations.lede}
        index="03"
      />

      <div className="integrations__board">
        <span className="integrations__wire integrations__wire--x" aria-hidden="true" />
        <span className="integrations__wire integrations__wire--y" aria-hidden="true" />
        <span className="integrations__hub" aria-hidden="true">
          <span className="integrations__hub-mark">DS</span>
          <span className="integrations__hub-label">{integrations.hubLabel}</span>
        </span>

        <ul className="integrations__systems">
          {integrations.systems.map((system, index) => (
            <li key={system.code}>
              <Reveal variant="rise" delay={index * 90} className="integrations__reveal">
                <article className="integrations__system">
                  <span className="integrations__code" aria-hidden="true">
                    {system.code}
                  </span>
                  <h3 className="integrations__title">{system.title}</h3>
                  <p className="integrations__body">{system.body}</p>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>

      <div className="integrations__capabilities">
        <h3 className="integrations__capabilities-title">{integrations.capabilitiesTitle}</h3>
        <ol className="integrations__capability-list">
          {integrations.capabilities.map((capability, index) => (
            <li className="integrations__capability" key={capability}>
              <span className="integrations__capability-index" aria-hidden="true">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span>{capability}</span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
